var Analytics = $.extend(false, BaseModule ,{
    
    init:function()
    {
        var module_name = this.data.module,module = this;
    }
    
});

$(document).ready(function(){
    "use strict";
    Analytics.init();
});
